module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.emitClick
    }
  }, [_vm._v("TEST " + _vm._s(_vm.message))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d2bbaea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 1945
// module chunks = 1